import * as axios from 'axios';
const axiosServices = axios.create();

export default axiosServices;
